import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "file_size_format",
	standalone: false
})
export class FileSizeFormatPipe implements PipeTransform {
	public transform(fileSizeInBytes): string {
		let i = -1;
		const byteUnits = ["KB", "MB"];
		const isKiloByte = fileSizeInBytes < 999999;
		do {
			fileSizeInBytes /= 1000;
			i++;
		} while (fileSizeInBytes > 1000);
		return Math.max(fileSizeInBytes, 0.1).toFixed(isKiloByte ? 0 : 2) + byteUnits[i];
	}
}
